import { render } from "./submit-review.vue?vue&type=template&id=45245003&ts=true"
import script from "./submit-review.ts?vue&type=script&lang=ts&external"
export * from "./submit-review.ts?vue&type=script&lang=ts&external"

import "./submit-review.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__